import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[alphanumeric]'
})
export class AlphanumericDirective implements OnInit {
  constructor(
    private el: ElementRef,
    private control: NgControl
  ) { }

  ngOnInit() {
    const initialValue = this.control.control.value;

    if (initialValue) {

      const isValidInitialValue = /^[a-zA-Z0-9]+$/g.test(initialValue);

      this.control.control.setErrors(
        isValidInitialValue ? null : { invalidInitialValue: true }
      );

      this.control.control.markAsTouched();
    }
  }

  @HostListener('input', ['$event']) onInputChange(event) {
    const currentValue = this.el.nativeElement.value;
    const maxLength = parseInt(this.el.nativeElement.getAttribute('maxlength'));
    const isWithinMaxLength = currentValue.length <= maxLength;

    this.control.control.setErrors(
      isWithinMaxLength ? null : { maxLengthExceeded: true }
    );

    this.control.control.setValue(
      currentValue.replace(/[^a-zA-Z0-9]/gi, '').substr(0, maxLength)
    );

    if (currentValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
